import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"

export const fetchClassesTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  id: "fetchClasses",
  invoke: {
    src: () => {
      return Promise.resolve([])
    },
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => ({
        // TODO: Update context with data.
        assignableClasses: evt.data
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("fetchClasses", {
            messageData: ["get available classes"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
